import { useTranslation } from "react-i18next";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";

export default function ReservableSlot({
  slot,
  onClick,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  const { t } = useTranslation("", { keyPrefix: "calendar" });
  return (
    <div
      role="button"
      onClick={() => onClick(slot)}
      className="w-full m-1 overflow-y-auto rounded-md bg-brandblue-50 hover:bg-brandblue-100"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%232491FFFF' strokeWidth='2' stroke-dasharray='16%2c9' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
      }}
    >
      <p className="flex justify-center items-center h-full text-brandblue-300 text-xs font-bold">
        {t("schedule")}
      </p>
    </div>
  );
}
